'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PromizeUploadImage = function (_React$Component) {
    _inherits(PromizeUploadImage, _React$Component);

    //static pzUploadedImageCount = 0;
    function PromizeUploadImage(props) {
        _classCallCheck(this, PromizeUploadImage);

        var _this = _possibleConstructorReturn(this, (PromizeUploadImage.__proto__ || Object.getPrototypeOf(PromizeUploadImage)).call(this, props));

        _this.repeatUploadedImageTop = { '3/4': 1002, '3/8': 980, '5/8': 950, '1': 920 };
        _this.repeatUploadedImageHeight = { '3/4': 27, '3/8': 14, '5/8': 26, '1': 45 };

        _this.pzUpload = function (event, imageDetail) {
            event.preventDefault();
            var promizeThreeDObj = _this.props.promizeThreeDObj;
            var _this$props = _this.props,
                pzCanvasObject = _this$props.pzCanvasObject,
                pzCanvas = _this$props.pzCanvas,
                pzCurrentView = _this$props.pzCurrentView,
                pzApiUrl = _this$props.pzApiUrl,
                pzImgUrl = _this$props.pzImgUrl,
                pzReplaceImg = './assets/images/',
                pzActiveImages = _this$props.pzActiveImages,
                pzCopyObjectsKeys = _this$props.pzCopyObjectsKeys,
                pzCopyOuterObjKeys = _this$props.pzCopyOuterObjKeys,
                pzCopyInnerObjKeys = _this$props.pzCopyInnerObjKeys,
                pzCopyOuterRepeatObjects = _this$props.pzCopyOuterRepeatObjects,
                pzIsCopyRepeatObjects = _this$props.pzIsCopyRepeatObjects;


            var tabData = _this.props.pzSubTab ? _this.props.pzSubTab : _this.props.pzTab;

            var uploadImageCount = _this.props.HomeComponent.pzSendIncrementValueByType('image'); //PromizeUploadImage.pzUploadedImageCount++;


            var pzImageProperty = {};
            var imageBoundary = imageDetail.boundary_position ? JSON.parse(imageDetail.boundary_position) : '';

            var _ref = imageBoundary && _this.props.pzCurrentView in imageBoundary ? imageBoundary[pzCurrentView][0] : '',
                _ref$width = _ref.width,
                width = _ref$width === undefined ? 1000 : _ref$width,
                _ref$height = _ref.height,
                height = _ref$height === undefined ? 1000 : _ref$height;

            if (!imageBoundary) {
                var currUploadedImg = new Image();
                currUploadedImg.src = window.URL.createObjectURL(event.target.files[0]);
                currUploadedImg.onload = function () {

                    width = currUploadedImg.width < width ? currUploadedImg.width : width;
                    height = currUploadedImg.height < height ? currUploadedImg.height : height;
                };
            }

            if (_this.state.img_error_msg != '') {
                _this.setState({ img_error_msg: "" });
            }
            var imgUploadStatus = _this.pzUploadValidation(event, imageDetail);

            var pzObjName = "FObject_image_" + imageDetail.promize_tab_attribute_id + '_' + uploadImageCount + '_' + uploadImageCount;

            if (imgUploadStatus['imgStatus']) {
                var objectSpacing = {};
                var objSpacing = _this.state.sliderValue;

                Object.keys(pzCanvasObject).map(function (objKey, objIdx) {
                    if (pzCanvasObject[objKey].tabAttrId === imageDetail.promize_tab_attribute_id && pzCanvasObject[objKey].customType == "uploadimage") {
                        objectSpacing[objKey] = parseInt(pzCanvasObject[objKey]['objectSpacing']);
                        objSpacing = parseInt(pzCanvasObject[objKey]['objectSpacing']);
                    }
                });

                var linkModelAttr = imageDetail.link_model_attributes ? JSON.parse(imageDetail.link_model_attributes) : '';
                var partNames = {};
                var ImagePartData = {};

                if (linkModelAttr.length > 0) {
                    partNames = linkModelAttr[0].part_names;
                    _this.props.HomeComponent.pzTurnModel(partNames[0]);
                    partNames && Object.values(partNames).map(function (partName, idx) {
                        var uploadedImageData = {};
                        uploadedImageData['addImage'] = {};
                        uploadedImageData['addImage'][pzObjName] = {
                            image: event.target.files[0],
                            properties: {
                                left: 0,
                                top: 2048,
                                originX: 'center',
                                originY: 'center',
                                scaleX: 1,
                                scaleY: 1,
                                applyFullScreen: false,
                                maxWidth: 2048,
                                maxHeight: _this.props.pzSizeProperties[_this.props.pzBaseType].maxHeight,
                                selectable: false,
                                lockMovement: true,
                                evented: false
                            }
                        };
                        ImagePartData[partName] = {
                            uploadData: uploadedImageData,
                            repeatSettings: {
                                spacing: 0,
                                groupSpacing: 0,
                                objectSpacing: _defineProperty({}, pzObjName, objSpacing)
                                //objectSpacing: objectSpacing
                            }
                        };
                    });
                    if (!pzIsCopyRepeatObjects) {
                        var data3_8 = {
                            name: 'tag_component',
                            component: {
                                name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                                component: {
                                    name: 'tag',
                                    customizationData: {
                                        repeatData: {
                                            '3d-customization-normal-repeat': ImagePartData
                                        }
                                    }
                                }
                            }
                        };
                        promizeThreeDObj.updateComponent(data3_8);
                    }
                    var imageObjectSpacing = objSpacing; //this.state.sliderValue;


                    console.log("pzApiUrl ", pzApiUrl);

                    var formData = new FormData();
                    formData.append("file", event.target.files[0]);
                    formData.append("name", 'uploadimage');
                  var currApiUrl = pzApiUrl;
                    var currImgUrl = pzImgUrl; //'https://devcloud.productimize.com/v3/promizenode/';
                    //fetch(pzApiUrl + "uploadImageWithDpi/" + parseInt(width) + '/' + parseInt(height) + '/2', {
                    fetch(currApiUrl + "uploadImageWithDpi/" + parseInt(width) + '/' + parseInt(height) + '/2', {
                        method: "POST",
                        body: formData
                    }).then(function (res) {
                        return res.json();
                    }).then(function (response) {
                        var originalImgSrc = response.coverted_image ? currImgUrl + response.coverted_image.replace(pzReplaceImg, '') : '';
                        var resizedImage = response.resized_image ? currImgUrl + response.resized_image.replace(pzReplaceImg, '') : '';
                        //let removedWhiteImage = pzApiUrl + response.removed_white_image.slice(1)
                        if (pzActiveImages[imageDetail.promize_tab_image_attribute_values_id] == undefined) {
                            pzActiveImages[imageDetail.promize_tab_image_attribute_values_id] = {};
                        }
                        //let removeWhite = pzActiveImages[imageDetail.promize_tab_image_attribute_values_id][uploadImageCount] ? pzActiveImages[imageDetail.promize_tab_image_attribute_values_id][uploadImageCount][2] : false
                        // let img_url = removeWhite ? removedWhiteImage : resizedImage

                        //pzActiveImages[imageDetail.promize_tab_image_attribute_values_id][uploadImageCount] = [resizedImage, removedWhiteImage, removeWhite];

                        pzActiveImages[imageDetail.promize_tab_image_attribute_values_id][uploadImageCount] = [resizedImage];
                        var img_url = resizedImage;

                        pzImageProperty = _extends({}, tabData, imageDetail, {

                            boundary: imageBoundary,
                            index: uploadImageCount,
                            imageIndex: uploadImageCount,
                            removedWhiteImage: '',
                            resizedImage: resizedImage,
                            removeWhite: '',
                            originalImageSrc: originalImgSrc
                        });

                        console.log("response.density  ", response.density);
                        pzImageProperty['dpiMatched'] = true;

                        if (response.density < 300) {
                            pzImageProperty['dpiMatched'] = false;
                        }
                        // TODO - Change original file
                        pzImageProperty['src'] = img_url;

                        var pzObject = _this.props.HomeComponent.pzCreateCartProperties('uploadimage', pzImageProperty);

                        var currObjKey = pzObject.name;
                        pzCanvasObject[pzObject.name] = pzObject;
                        pzCanvasObject[pzObject.name]['partNames'] = [partNames[0]];
                        pzCanvasObject[pzObject.name]['objectSpacing'] = imageObjectSpacing;
                        pzCanvasObject[pzObject.name]['fileEvent'] = event.target.files[0];
                        pzCanvasObject[pzObject.name]['imageIndex'] = uploadImageCount;

                        if (!pzCopyOuterRepeatObjects.includes(currObjKey) && (currObjKey.includes(pzCopyOuterObjKeys[0]) || currObjKey.includes(pzCopyOuterObjKeys[1]))) {
                            pzCopyOuterRepeatObjects.push(currObjKey);
                        }
                        if (!pzCopyObjectsKeys.includes(pzObject.name)) {
                            pzCopyObjectsKeys.push(pzObject.name);
                        }

                        if (pzIsCopyRepeatObjects) {
                            var objName = currObjKey;
                            var name = '';
                            var isSameObject = 0,
                                tabAttributeId = 0;
                            if (objName.includes(pzCopyOuterObjKeys[0]) || objName.includes(pzCopyOuterObjKeys[1])) {
                                isSameObject = 1;
                            } else if (objName.includes(pzCopyInnerObjKeys[0]) || objName.includes(pzCopyInnerObjKeys[1])) {
                                isSameObject = 2;
                            }
                            if (isSameObject == 1) {
                                if (pzCopyOuterObjKeys[0].includes('image')) {
                                    //name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[0])

                                    if (pzCopyInnerObjKeys[0].includes('image')) {
                                        name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[0]);
                                        tabAttributeId = pzCopyInnerObjKeys[0].split('_')[1];
                                    } else if (pzCopyInnerObjKeys[1].includes('image')) {
                                        name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[1]);
                                        tabAttributeId = pzCopyInnerObjKeys[1].split('_')[1];
                                    }
                                } else if (pzCopyOuterObjKeys[1].includes('image')) {
                                    //name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[0])

                                    if (pzCopyInnerObjKeys[0].includes('image')) {
                                        name = objName.replace(pzCopyOuterObjKeys[1], pzCopyInnerObjKeys[0]);
                                        tabAttributeId = pzCopyInnerObjKeys[0].split('_')[1];
                                    } else if (pzCopyInnerObjKeys[1].includes('image')) {
                                        name = objName.replace(pzCopyOuterObjKeys[1], pzCopyInnerObjKeys[1]);
                                        tabAttributeId = pzCopyInnerObjKeys[1].split('_')[1];
                                    }
                                }
                            } else if (isSameObject == 2) {
                                if (pzCopyInnerObjKeys[0].includes('image')) {
                                    //name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[0])
                                    if (pzCopyOuterObjKeys[0].includes('image')) {
                                        name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[0]);
                                        tabAttributeId = pzCopyOuterObjKeys[0].split('_')[1];
                                    } else if (pzCopyOuterObjKeys[1].includes('image')) {
                                        name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[1]);
                                        tabAttributeId = pzCopyOuterObjKeys[1].split('_')[1];
                                    }
                                } else if (pzCopyInnerObjKeys[1].includes('image')) {
                                    //name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[0])
                                    if (pzCopyOuterObjKeys[0].includes('images')) {
                                        name = objName.replace(pzCopyInnerObjKeys[1], pzCopyOuterObjKeys[0]);
                                        tabAttributeId = pzCopyOuterObjKeys[0].split('_')[1];
                                    } else if (pzCopyOuterObjKeys[1].includes('image')) {
                                        name = objName.replace(pzCopyInnerObjKeys[1], pzCopyOuterObjKeys[1]);
                                        tabAttributeId = pzCopyOuterObjKeys[1].split('_')[1];
                                    }
                                }
                            }
                            var currPartNames = [partNames[0]];
                            if (partNames) {
                                if (partNames[0] == "outside") {
                                    currPartNames[0] = "inside";
                                } else {
                                    currPartNames[0] = "outside";
                                }
                            }
                            pzCanvasObject[name] = {};
                            pzCanvasObject[name] = Object.assign({}, _extends({}, pzCanvasObject[objName]), { 'partNames': currPartNames });
                            pzCanvasObject[name].name = name;
                            pzCanvasObject[name].tabAttrId = tabAttributeId;

                            /** Back side data update code starts here **/
                            // Form another side data when apply to both sides selected
                            var uploadedImageData = {};
                            uploadedImageData['addImage'] = {};
                            uploadedImageData['addImage'][name] = {
                                image: event.target.files[0],
                                properties: {
                                    left: 0,
                                    top: 2048,
                                    originX: 'center',
                                    originY: 'center',
                                    scaleX: 1,
                                    scaleY: 1,
                                    applyFullScreen: false,
                                    maxWidth: 2048,
                                    maxHeight: _this.props.pzSizeProperties[_this.props.pzBaseType].maxHeight,
                                    selectable: false,
                                    lockMovement: true,
                                    evented: false
                                }
                            };
                            ImagePartData[currPartNames[0]] = {
                                uploadData: uploadedImageData,
                                repeatSettings: {
                                    spacing: 0,
                                    groupSpacing: 0,
                                    objectSpacing: _defineProperty({}, name, pzCanvasObject[name].objectSpacing)
                                    //objectSpacing: objectSpacing
                                }

                                // Apply to another view 
                            };var customImgData = {
                                name: 'tag_component',
                                component: {
                                    name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                                    component: {
                                        name: 'tag',
                                        customizationData: {
                                            repeatData: {
                                                '3d-customization-normal-repeat': ImagePartData
                                            }
                                        }
                                    }
                                }
                            };
                            promizeThreeDObj.updateComponent(customImgData);
                            /** Back side data update code ends here **/

                            if (!pzCopyOuterRepeatObjects.includes(name) && (name.includes(pzCopyOuterObjKeys[0]) || name.includes(pzCopyOuterObjKeys[1]))) {
                                pzCopyOuterRepeatObjects.push(name);
                            }
                            if (!pzCopyObjectsKeys.includes(name)) {
                                pzCopyObjectsKeys.push(name);
                            }
                        }

                        _this.props.HomeComponent.setState({ pzCanvasObject: pzCanvasObject, pzActiveImages: pzActiveImages, pzCopyObjectsKeys: pzCopyObjectsKeys }, function () {

                            event.target.value = "";
                        });
                    });
                } else {
                    _this.setState({ img_error_msg: imgUploadStatus['imgErrorMsg'] });
                }
            } else {
                _this.setState({ img_error_msg: imgUploadStatus['imgErrorMsg'] });
            }
        };

        _this.pzUploadValidation = function (event, imageDetail) {

            var files = event.target.files[0];
            var pzAttrImageValue = imageDetail.promize_attribute_image_value;
            var pzMaxUploadSize = pzAttrImageValue.max_upload_size ? pzAttrImageValue.max_upload_size : 1;
            var pzMinUploadSize = pzAttrImageValue.min_upload_size ? pzAttrImageValue.min_upload_size : 0;
            var imgStatus = true;

            var imgErrorMsg = '';
            var imgStatusArray = [];
            var fileExtension = files.name.split('.').pop();
            //var fileExtensionArray = pzAttrImageValue.image_format.split(',');
            //var allowedFileExtensionArray = pzAttrImageValue.image_format.split(',');
            var allowedFileExtensionArray = pzAttrImageValue.image_format.split(/[\s, ]+/);
            var fileExtensionArray = allowedFileExtensionArray.map(function (item) {
                return item.toLowerCase();
            });
            fileExtension = fileExtension.toLowerCase();
            if (fileExtensionArray.length > 0 && !fileExtensionArray.includes(fileExtension)) {
                imgStatus = false;
                imgErrorMsg = 'File extension is Invalid!';
            }
            var fileSize = files.size / (2048 * 2048);
            //console.log("fileSize ==> ", fileSize)
            if (fileSize > pzMaxUploadSize || fileSize < pzMinUploadSize) {
                imgStatus = false;
                imgErrorMsg = 'Uploaded Image file size should be between';

                if (pzMinUploadSize == 0) {
                    imgErrorMsg += ' 1 KB';
                } else {
                    imgErrorMsg += ' ' + pzMinUploadSize + ' MB';
                }
                imgErrorMsg += ' and ' + pzMaxUploadSize + ' MB';
            }

            var imageArray = _this.props.pzActiveImages[imageDetail.promize_tab_image_attribute_values_id];
            if (imageDetail.max_image_limit != null && imageArray && imageDetail.max_image_limit < imageArray.length + 1) {
                imgStatus = false;
                imgErrorMsg = 'Sorry! you can upload maximum of ' + imageDetail.max_image_limit + ' file(s)';
            }
            imgStatusArray['imgStatus'] = imgStatus;
            imgStatusArray['imgErrorMsg'] = imgErrorMsg;
            // console.log("imgStatusArray ", imgStatusArray)
            return imgStatusArray;
        };

        _this.handleSpacing = function (e) {
            var pzImgDetail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            e.preventDefault();
            var _this$props2 = _this.props,
                pzCanvasObject = _this$props2.pzCanvasObject,
                pzIsCopyRepeatObjects = _this$props2.pzIsCopyRepeatObjects;

            var objectSpacing = {};

            Object.keys(pzCanvasObject).map(function (objKey, objIdx) {
                if (pzCanvasObject[objKey].tabAttrId === pzImgDetail.promize_tab_attribute_id && pzCanvasObject[objKey].customType == "uploadimage") {
                    objectSpacing[objKey] = parseInt(e.target.value);
                }
            });

            pzCanvasObject['imageSpacing'] = e.target.value;
            _this.props.HomeComponent.setState({ pzCanvasObject: pzCanvasObject }, function () {
                if (pzIsCopyRepeatObjects) {
                    //console.log("%c APPLY2dObjecs", 'background:blue; color:white')
                    _this.props.HomeComponent.apply2dObjects();
                }
            });

            _this.setState({ sliderValue: e.target.value }, function () {

                //console.log("spcaeval==>", this.state.sliderValue)

                if (!pzIsCopyRepeatObjects) {
                    var promizeThreeDObj = _this.props.promizeThreeDObj;


                    var partNames = {};
                    var textPartData = {};

                    if (pzImgDetail) {
                        var linkModelAttr = pzImgDetail.link_model_attributes ? JSON.parse(pzImgDetail.link_model_attributes) : '';

                        if (linkModelAttr.length > 0) {
                            partNames = linkModelAttr[0].part_names;
                            partNames && Object.values(partNames).map(function (partName, idx) {
                                textPartData[partName] = {
                                    repeatSettings: {
                                        objectSpacing: objectSpacing
                                    }
                                };
                            });
                        }
                        var data3_8 = {
                            name: 'tag_component',
                            component: {
                                name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                                component: {
                                    name: 'tag',
                                    customizationData: {
                                        upload: [{}],
                                        repeatData: {
                                            '3d-customization-normal-repeat': textPartData
                                        }
                                    }
                                }
                            }
                            //console.log("SPACING DATA === ", data3_8)
                        };promizeThreeDObj.updateComponent(data3_8);
                    }
                }
            });
        };

        _this.pzRemoveImagesFromCanvasOLD = function (partNames, imageIdx) {
            var promizeThreeDObj = _this.props.promizeThreeDObj;

            var ImagePartData = {};
            partNames && Object.values(partNames).map(function (partName, idx) {

                ImagePartData[partName] = {
                    repeatSettings: {

                        objectSpacing: _this.state.sliderValue
                    },

                    upload: {}
                };
                var data3_8 = {
                    name: 'tag_component',
                    component: {
                        name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                        component: {
                            name: 'tag',
                            customizationData: {
                                upload: [{}],
                                repeatData: {
                                    '3d-customization-normal-repeat': ImagePartData
                                }

                            }
                        }
                    }
                };

                var uploadedImageData = {};
                uploadedImageData['removeImage'] = [];
                uploadedImageData['removeImage'].push(partName + '_' + imageIdx);

                var customizationData = promizeThreeDObj.getComponentData(data3_8, 'customizationData');
                customizationData.repeatData['3d-customization-normal-repeat'][partName].uploadData = uploadedImageData;
                customizationData.repeatData['3d-customization-normal-repeat'][partName].repeatSettings.objectSpacing = 1;
                promizeThreeDObj.updateComponent(data3_8);
            });
        };

        _this.pzRemoveImagesFromCanvas = function (partNames, imageIdx) {
            var promizeThreeDObj = _this.props.promizeThreeDObj;

            var ImagePartData = {};
            var uploadedImageData = {};
            uploadedImageData['removeImage'] = [imageIdx];
            partNames && Object.values(partNames).map(function (partName, idx) {

                ImagePartData[partName] = {
                    repeatSettings: {
                        spacing: 0,
                        groupSpacing: 0,
                        objectSpacing: {}
                    },
                    uploadData: uploadedImageData
                };
                var data3_8 = {
                    name: 'tag_component',
                    component: {
                        name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                        component: {
                            name: 'tag',
                            customizationData: {
                                uploadData: [{}],
                                repeatData: {
                                    '3d-customization-normal-repeat': ImagePartData
                                }

                            }
                        }
                    }

                    //let uploadedImageData = {};
                    //uploadedImageData['removeImage'] = []
                    //uploadedImageData['removeImage'].push(partName + '_' + (imageIdx));

                    //const customizationData = promizeThreeDObj.getComponentData(data3_8, 'customizationData')
                    //customizationData.repeatData['3d-customization-normal-repeat'][partName].uploadData = uploadedImageData;
                    //customizationData.repeatData['3d-customization-normal-repeat'][partName].repeatSettings.objectSpacing = 1;

                    //console.log("data3_8 ", data3_8)
                };promizeThreeDObj.updateComponent(data3_8);
            });
        };

        _this.pzRemoveImage = function (pzCanvasKey) {
            var _this$props3 = _this.props,
                pzActiveImages = _this$props3.pzActiveImages,
                promizeThreeDObj = _this$props3.promizeThreeDObj,
                pzCopyObjectsKeys = _this$props3.pzCopyObjectsKeys,
                pzIsCopyRepeatObjects = _this$props3.pzIsCopyRepeatObjects,
                pzCopyOuterObjKeys = _this$props3.pzCopyOuterObjKeys,
                pzCopyInnerObjKeys = _this$props3.pzCopyInnerObjKeys;
            var _this$props4 = _this.props,
                pzCanvasObject = _this$props4.pzCanvasObject,
                pzCanvas = _this$props4.pzCanvas,
                pzCurrentView = _this$props4.pzCurrentView;

            // console.log("pzCanvasKey ", pzCanvasKey)

            var objKeyIndex = pzCopyObjectsKeys.indexOf(pzCanvasKey);
            // console.log("objKeyIndex ", objKeyIndex)

            if (objKeyIndex > -1) {
                pzCopyObjectsKeys.splice(objKeyIndex, 1);
            }

            var currCanvasObj = pzCanvasObject[pzCanvasKey];
            //this.pzRemoveImagesFromCanvas(currCanvasObj.partNames, currCanvasObj.imageIndex)
            _this.pzRemoveImagesFromCanvas(currCanvasObj.partNames, pzCanvasKey);
            delete pzCanvasObject[pzCanvasKey];
            delete pzActiveImages[currCanvasObj.tabAttrValueId][currCanvasObj.imageIndex];

            if (pzIsCopyRepeatObjects) {

                var objName = pzCanvasKey;

                var name = '';
                var isSameObject = 0;

                if (objName.includes(pzCopyOuterObjKeys[0]) || objName.includes(pzCopyOuterObjKeys[1])) {
                    isSameObject = 1;
                } else if (objName.includes(pzCopyInnerObjKeys[0]) || objName.includes(pzCopyInnerObjKeys[1])) {
                    isSameObject = 2;
                }

                if (isSameObject == 1) {
                    if (pzCopyOuterObjKeys[0].includes('image')) {
                        //name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[0])

                        if (pzCopyInnerObjKeys[0].includes('image')) {
                            name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[0]);
                        } else if (pzCopyInnerObjKeys[1].includes('image')) {
                            name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[1]);
                        }
                    } else if (pzCopyOuterObjKeys[1].includes('image')) {
                        //name = objName.replace(pzCopyOuterObjKeys[0], pzCopyInnerObjKeys[0])

                        if (pzCopyInnerObjKeys[0].includes('image')) {
                            name = objName.replace(pzCopyOuterObjKeys[1], pzCopyInnerObjKeys[0]);
                        } else if (pzCopyInnerObjKeys[1].includes('image')) {
                            name = objName.replace(pzCopyOuterObjKeys[1], pzCopyInnerObjKeys[1]);
                        }
                    }
                } else if (isSameObject == 2) {
                    if (pzCopyInnerObjKeys[0].includes('image')) {
                        //name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[0])
                        if (pzCopyOuterObjKeys[0].includes('image')) {
                            name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[0]);
                        } else if (pzCopyOuterObjKeys[1].includes('image')) {
                            name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[1]);
                        }
                    } else if (pzCopyInnerObjKeys[1].includes('image')) {
                        //name = objName.replace(pzCopyInnerObjKeys[0], pzCopyOuterObjKeys[0])
                        if (pzCopyOuterObjKeys[0].includes('images')) {
                            name = objName.replace(pzCopyInnerObjKeys[1], pzCopyOuterObjKeys[0]);
                        } else if (pzCopyOuterObjKeys[1].includes('image')) {
                            name = objName.replace(pzCopyInnerObjKeys[1], pzCopyOuterObjKeys[1]);
                        }
                    }
                }
                //console.log("APPLY DELETE name  => ", name)
                var currCanvasObj = pzCanvasObject[name];
                //this.pzRemoveImagesFromCanvas(currCanvasObj.partNames, currCanvasObj.imageIndex)
                _this.pzRemoveImagesFromCanvas(currCanvasObj.partNames, name);
                var keyIndex = pzCopyObjectsKeys.indexOf(name);
                //console.log(" APPLY DELETEkeyIndex ", keyIndex)
                if (keyIndex > -1) {
                    pzCopyObjectsKeys.splice(keyIndex, 1);
                }

                delete pzCanvasObject[name];
            }

            _this.props.HomeComponent.setState({ pzActiveImages: pzActiveImages, pzCanvasObject: pzCanvasObject, pzCopyObjectsKeys: pzCopyObjectsKeys }, function () {
                /* if (pzIsCopyRepeatObjects) {
                    console.log("%c APPLY2dObjecs", 'background:blue; color:white')
                    this.props.HomeComponent.apply2dObjects();
                } */
            });

            if (!pzIsCopyRepeatObjects) {

                //var linkModelAttr = (imageDetail.link_model_attributes) ? JSON.parse(imageDetail.link_model_attributes) : '';
                var partNames = currCanvasObj.partNames;
                var ImagePartData = {};
                if (partNames.length > 0) {
                    //partNames = linkModelAttr[0].part_names;
                    partNames && Object.values(partNames).map(function (partName, idx) {
                        ImagePartData[partName] = {
                            repeatSettings: {
                                spacing: 0,
                                groupSpacing: 0,
                                objectSpacing: {}
                            },
                            uploadData: {
                                image: ''
                            }
                        };
                    });
                }

                var uploadedImageData = {};
                uploadedImageData['removeImage'] = [];
                uploadedImageData['removeImage'].push(partNames[0] + '_' + currCanvasObj.imageIndex);

                var data3_8 = {
                    name: 'tag_component',
                    component: {
                        name: _this.props.pzBaseType ? _this.props.pzBaseType : '3/4',
                        component: {
                            name: 'tag',
                            customizationData: {
                                uploadData: uploadedImageData,
                                repeatData: {
                                    '3d-customization-normal-repeat': ImagePartData
                                }
                            }
                        }
                    }
                };

                var customizationData = promizeThreeDObj.getComponentData(data3_8, 'customizationData');
                customizationData.repeatData['3d-customization-normal-repeat'][partNames[0]].uploadData = uploadedImageData;
                customizationData.repeatData['3d-customization-normal-repeat'][partNames[0]].uploadobjectSpacing = 1;
                promizeThreeDObj.updateComponent(data3_8);
            }
        };

        _this.pzRemoveWhite = function (e, imageDetail) {
            var pzActiveImages = _this.props.pzActiveImages;

            pzActiveImages[imageDetail.promize_tab_image_attribute_values_id][0][2] = e.target.checked;
            var imageBoundary = imageDetail.boundary_position ? JSON.parse(imageDetail.boundary_position) : '';
            var _this$props5 = _this.props,
                pzCanvasObject = _this$props5.pzCanvasObject,
                pzCanvas = _this$props5.pzCanvas,
                pzCurrentView = _this$props5.pzCurrentView;

            if (Object.keys(imageBoundary).length > 0) {
                pzActiveImages[imageDetail.promize_tab_image_attribute_values_id].map(function (img, img_index) {
                    imageBoundary[pzCurrentView].map(function (boundary, index) {
                        var objName = "FObject_image_" + imageDetail.promize_tab_attribute_id + '_' + index + '_' + img_index;
                        var canvasObj = pzCanvas.getItemByName(objName);
                        canvasObj['src'] = e.target.checked ? canvasObj.removedWhiteImage : canvasObj.resizedImage;
                        canvasObj['removeWhite'] = e.target.checked;
                        pzCanvasObject[pzCurrentView][objName].src = e.target.checked ? canvasObj.removedWhiteImage : canvasObj.resizedImage;
                        pzCanvasObject[pzCurrentView][objName].removeWhite = e.target.checked;
                        pzAddObjectToCanvas(pzCanvas, canvasObj);
                    });
                });
            }
            _this.props.HomeComponent.setState({ pzActiveImages: pzActiveImages, pzCanvasObject: pzCanvasObject });
        };

        _this.state = {

            img_error_msg: '',
            imageSelectable: true,
            showboundary: 0,
            sliderValue: 20,
            pzSettings: { enableRemoveWhite: false }
        };

        return _this;
    }

    //pzRemoveImage = (image_index, imageDetail) => {


    _createClass(PromizeUploadImage, [{
        key: 'render',
        value: function render() {
            var pzAttributeSettings = this.props.pzAttribute.promize_attribute.promize_attribute_settings;
            var pzSettings = this.state.pzSettings;

            if (pzAttributeSettings.length > 0) {
                var enableRemoveWhite = pzAttributeSettings.find(function (val) {
                    return val.promize_setting.reference_id == 4;
                });
                pzSettings.enableRemoveWhite = enableRemoveWhite ? true : false;
            }
            return React.createElement(
                React.Fragment,
                null,
                React.createElement(PZUploadImage, _extends({ ImageComponent: this, pzRemoveImage: this.pzRemoveImage, pzRemoveWhite: this.pzRemoveWhite, pzSettings: pzSettings, pzUpload: this.pzUpload }, this.props, this.state))
            );
        }
    }]);

    return PromizeUploadImage;
}(React.Component);